import React from 'react';
import { handleActionError } from '../../utils/engineering-tools';
import { GreaseQuantityPayload, TimkenGreaseFillOption } from '../../../components/bearing-search/types/types';

export type InitialGreaseFillState = {
	option: TimkenGreaseFillOption;
	requestData?: GreaseQuantityPayload;
};

export const initialInitialGreaseFillState: InitialGreaseFillState = {
	option: 'PartNumber',
};

export type InitialGreaseFillAction =
	| { type: 'change_option'; payload: TimkenGreaseFillOption }
	| { type: 'reset'; payload?: InitialGreaseFillState };

const initialGreaseFillReducer: React.Reducer<
	InitialGreaseFillState,
	InitialGreaseFillAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_option': {
			return {
				...state,
				option: action.payload,
			};
		}
		case 'reset': {
			const newState = action.payload ? action.payload : initialInitialGreaseFillState;

			return {
				...newState,
			};
		}
	}

	return handleActionError( action );
};

export default initialGreaseFillReducer;
